/* Base translations · W12 worksheet — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): w12. */
export const I18N_BASE_W12 = {
  en: {
    w12: {
      title: "File assembly", subtitle: "Post-report assembly of the audit file (W12).",
      status: "Status", reportDate: "Date of the auditor's report",
      setBy: "Set by {name} · {date}",
      reportDateSetOk: "Report date saved.",
      reportDateSetError: "Failed to save the report date.",
      isa230Info: "ISA 230: assembly ordinarily within 60 days of the report date — {date}",
      isa230InfoUnset: "Enter the report date to see the ISA 230 reference date.",
      markComplete: "Mark assembly complete", working: "Working…",
      complete: "Assembly complete · signed off by {name} · {date}",
      markedOk: "Assembly marked complete. Engagement is locked.",
      needFinalReport: "Available once the auditor's report is Final.",
      partnerUnsigned: "The Partner has not signed this report version — a warning only; the file can still be marked complete.",
      needReportDate: "Enter the date of the auditor's report first.",
      amendments: "Post-assembly amendments",
      addAmendment: "Add amendment", reasonPh: "Reason (required)",
      areaPh: "Area / worksheet touched", reviewerPh: "Reviewer",
      reasonRequired: "Reason is required.",
      amendmentAdded: "Post-assembly amendment recorded.",
      noAmendments: "No amendments recorded.",
      h: { at: "When", by: "By", reviewer: "Reviewer", area: "Area", reason: "Reason" },
    },
  },
  ar: {
    w12: {
      title: "تجميع الملف", subtitle: "تجميع ملف المراجعة بعد إصدار التقرير (\u2066W12\u2069).",
      status: "الحالة", reportDate: "تاريخ تقرير المدقق",
      setBy: "أدخله {name} · {date}",
      reportDateSetOk: "تم حفظ تاريخ التقرير.",
      reportDateSetError: "تعذّر حفظ تاريخ التقرير.",
      isa230Info: "معيار المراجعة 230: يُستكمل تجميع الملف عادةً خلال 60 يومًا من تاريخ التقرير — {date}",
      isa230InfoUnset: "أدخل تاريخ التقرير لعرض التاريخ المرجعي وفق معيار المراجعة 230.",
      markComplete: "اعتماد اكتمال تجميع الملف", working: "جاري التنفيذ…",
      complete: "اكتمل تجميع الملف · اعتمده {name} · {date}",
      markedOk: "تم اعتماد اكتمال التجميع. المهمة الآن مقفلة.",
      needFinalReport: "يتاح بعد اعتماد تقرير المراجع نهائيًا.",
      partnerUnsigned: "لم يوقّع الشريك على هذا الإصدار من التقرير — تنبيه فقط؛ يمكن إتمام الملف مع ذلك.",
      needReportDate: "أدخل تاريخ تقرير المراجع أولًا.",
      amendments: "تعديل بعد تجميع الملف",
      addAmendment: "إضافة تعديل", reasonPh: "السبب (مطلوب)",
      areaPh: "المجال / ورقة العمل المعنية", reviewerPh: "المراجع",
      reasonRequired: "السبب مطلوب.",
      amendmentAdded: "تم تسجيل تعديل ما بعد التجميع.",
      noAmendments: "لا توجد تعديلات مسجَّلة.",
      h: { at: "التوقيت", by: "بواسطة", reviewer: "المراجع", area: "المجال", reason: "السبب" },
    },
  },
};

export default I18N_BASE_W12;
